import { registerComponent } from '@gig/magic-common';
import KeycloakConfigureOtpComponent from './keycloak-configure-otp.vue.js';

var KeycloakConfigureOtp = registerComponent(KeycloakConfigureOtpComponent);

export { KeycloakConfigureOtp };
